import {
  Box,
  Flex,
  Icon,
  SimpleGrid,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
// Custom components
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import { FaSave } from "react-icons/fa";
import { RiCouponFill } from "react-icons/ri";
import { CardInfoClick } from "./components/CardInfoClick";
import { useService } from "hooks/ServicesHook";
import { useQuery } from "react-query";

export default function ServicePage() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const { findCardsServices } = useService();
  const { data, isLoading, error } = useQuery(["findCardsServices"], () =>
    findCardsServices()
  );

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      {error ? (
        <Flex
          align="center"
          justify="center"
          direction="column"
          p={8}
          mb="20px"
          bg={boxBg}
          borderRadius="20px"
        >
          <Text color="red.500" fontSize="xl" fontWeight="bold" mb={2}>
            {String(error)}
          </Text>
        </Flex>
      ) : (
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 2, "2xl": 2 }}
          gap="20px"
          mb="20px"
        >
          <MiniStatistics
            loading={isLoading}
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={<Icon w="32px" h="32px" as={FaSave} color={brandColor} />}
              />
            }
            name="Clientes com BKP"
            value={data?.BKP}
          />

          <MiniStatistics
            loading={isLoading}
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon
                    w="32px"
                    h="32px"
                    as={RiCouponFill}
                    color={brandColor}
                  />
                }
              />
            }
            name="Clientes com NFCE"
            value={data?.NFCE}
          />

    
        </SimpleGrid>
      )}

      <SimpleGrid columns={{ base: 1, md: 3, lg: 3 }} gap="20px" mb="20px">
        <CardInfoClick />
      </SimpleGrid>
    </Box>
  );
}
